import axios from "axios";
import { masterDataApiConfig } from "@/constant/config";
//const queryString = require('query-string');
const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
};

export default {
    getPromotionBannerView() { 
        return axios({
            method: "GET",
            url: `${masterDataApiConfig.getPromotionBannerView}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
}